"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDividerRowStyle = exports.getOffsetRowStyle = exports.getMeasuredValueRowHeight = exports.getOriginalValueIndex = void 0;
const form_value_list_row_constants_1 = require("./form-value-list-row.constants");
const getOriginalValueIndex = (entry) => (entry.type === 'value' ? entry.index : -1);
exports.getOriginalValueIndex = getOriginalValueIndex;
const getMeasuredValueRowHeight = (element) => {
    const { height } = element.getBoundingClientRect();
    return Math.max(height + form_value_list_row_constants_1.ROW_OFFSET_PX, form_value_list_row_constants_1.LIST_ITEM_HEIGHT);
};
exports.getMeasuredValueRowHeight = getMeasuredValueRowHeight;
const getOffsetRowStyle = (style) => {
    var _a;
    return (Object.assign(Object.assign({}, style), { transform: `${(_a = style.transform) !== null && _a !== void 0 ? _a : ''} translateY(${form_value_list_row_constants_1.ROW_OFFSET_PX}px)`.trim() }));
};
exports.getOffsetRowStyle = getOffsetRowStyle;
const getDividerRowStyle = (style) => (Object.assign(Object.assign({}, style), { right: 0, width: 'unset' }));
exports.getDividerRowStyle = getDividerRowStyle;
